/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Casedatasourceyou3Inputs */

const en_casedatasourceyou3 = /** @type {(inputs: Casedatasourceyou3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`edited`)
};

const pt_casedatasourceyou3 = /** @type {(inputs: Casedatasourceyou3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`editado`)
};

/**
* | output |
* | --- |
* | "edited" |
*
* @param {Casedatasourceyou3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const casedatasourceyou3 = /** @type {((inputs?: Casedatasourceyou3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Casedatasourceyou3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_casedatasourceyou3(inputs)
	return pt_casedatasourceyou3(inputs)
});
export { casedatasourceyou3 as "caseDataSourceYou" }